import { render, staticRenderFns } from "./merchant-apply.vue?vue&type=template&id=1f61db07&scoped=true"
import script from "./merchant-apply.vue?vue&type=script&lang=js"
export * from "./merchant-apply.vue?vue&type=script&lang=js"
import style0 from "./merchant-apply.vue?vue&type=style&index=0&id=1f61db07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f61db07",
  null
  
)

export default component.exports